import React from 'react';
import { motion } from 'motion/react';

const Languages = () => {
  const springConfig = {
    type: "spring",
    damping: 80,
    stiffness: 400,
    mass: 1
  };

  const languages = [
    { script: "தமிழ்", name: "Tamil", words: 104 },
    { script: "हिन्दी", name: "Hindi", words: 100 },
    { script: "తెలుగు", name: "Telugu", words: 97 },
    { script: "ಕನ್ನಡ", name: "Kannada", words: 99 },
    { script: "മലയാളം", name: "Malayalam", words: 103 },
    { script: "বাংলা", name: "Bengali", words: 104 },
    { script: "ગુજરાતી", name: "Gujarati", words: 104 },
    { script: "ਪੰਜਾਬੀ", name: "Punjabi", words: 104 },
    { script: "मराठी", name: "Marathi", words: 104 },
    { script: "ଓଡ଼ିଆ", name: "Odia", words: 103 },
    { script: "اردو", name: "Urdu", words: 104 },
    { script: "অসমীয়া", name: "Assamese", words: 104 },
  ];

  return (
    <section className="py-24 bg-gradient-to-br from-orange-50 to-pink-50">
      <div className="container">
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={springConfig}
          className="text-center mb-16"
        >
          <div className="inline-flex items-center gap-2 bg-white text-orange-700 px-4 py-2 rounded-full mb-4 shadow-sm">
            <span>🌐</span>
            <span className="text-sm font-medium">Bilingual Mode</span>
          </div>
          <h2 
            className="heading-large mb-4"
            style={{
              fontSize: 'clamp(32px, 4vw, 48px)',
              fontWeight: 600,
              color: '#0A0A0A',
              letterSpacing: '-0.01em'
            }}
          >
            Type in 22 Indian Languages
          </h2>
          <p 
            className="body-large max-w-2xl mx-auto"
            style={{
              fontSize: '18px',
              color: '#3C3B3D',
              lineHeight: 1.6
            }}
          >
            Enable bilingual mode and type in English — get suggestions in Tamil, Hindi, Telugu and more. 
            <strong> Tanglish, Hinglish, Kanglish</strong> — all natural.
          </p>
        </motion.div>

        {/* How it works demo */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ ...springConfig, delay: 0.2 }}
          className="max-w-md mx-auto mb-12"
        >
          <div className="bg-white rounded-2xl p-6 shadow-lg border border-gray-200">
            <p className="text-sm text-gray-500 mb-3">How it works</p>
            <div className="flex items-center justify-center gap-4">
              <div className="text-center">
                <p className="text-sm text-gray-500">You type:</p>
                <p className="font-bold text-lg" style={{ color: '#0A0A0A' }}>vanakkam</p>
              </div>
              <div className="text-2xl">↓</div>
              <div className="text-center">
                <p className="text-2xl font-bold" style={{ color: '#FF6B9D' }}>வணக்கம்</p>
                <span className="text-green-500 text-sm">✓</span>
              </div>
            </div>
          </div>
          <p className="text-center text-sm text-gray-600 mt-4">
            100+ words per language, auto-suggest in prediction bar
          </p>
        </motion.div>

        {/* Languages Grid */}
        <div className="max-w-5xl mx-auto">
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4">
            {languages.map((lang, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, scale: 0.9 }}
                whileInView={{ opacity: 1, scale: 1 }}
                viewport={{ once: true }}
                transition={{ ...springConfig, delay: index * 0.05 }}
                whileHover={{ y: -4, transition: { duration: 0.2 } }}
                className="bg-white rounded-xl p-4 text-center shadow-sm border border-gray-100 hover:shadow-md transition-shadow"
              >
                <div 
                  className="text-2xl font-bold mb-1"
                  style={{ color: '#FF6B9D' }}
                >
                  {lang.script}
                </div>
                <div className="text-sm font-medium text-gray-900">{lang.name}</div>
                <div className="text-xs text-gray-500">{lang.words} words</div>
              </motion.div>
            ))}
          </div>

          {/* More languages note */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ ...springConfig, delay: 0.5 }}
            className="text-center mt-6"
          >
            <div className="inline-flex items-center gap-2 bg-white/80 backdrop-blur-sm px-6 py-3 rounded-full border border-gray-200">
              <span className="font-semibold" style={{ color: '#FF6B9D' }}>+ 10 more</span>
              <span className="text-gray-600 text-sm">Sanskrit, Nepali, Konkani, Sindhi, Maithili, Dogri...</span>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Languages;
